import { withStyles } from 'material-ui';
import React from 'react';
import MaterialTableRow from 'material-ui/Table/TableRow';

const TableRow = ({ children, classes, ...otherProps }) => {
    return (
        <MaterialTableRow className={classes.root}{...otherProps}>
            {children}
        </MaterialTableRow>
    );
};

const styles = theme => ({
    root: {
        height: '28px',
      },

});

export default withStyles(styles)(TableRow);